<template>
    <a-drawer
        :title="id === 0 ? 'Añadir nuevo artículo de compra' : 'Editar artículo de compra #' + id"
        :width="420"
        :visible="visible"
        :wrap-style="{ height: '100%', overflow: 'auto', paddingBottom: '108px' }"
        class="flex-1"
        @close="$emit('close')"
    >
        <validation-observer v-slot="{ passes, invalid }">
            <form @submit="passes(save)">
                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.name"
                            :app="app"
                            :item="id"
                            name="name"
                            title="Nombre"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.provider"
                            ret-label="name"
                            :app="app"
                            :item="id"
                            name="provider"
                            title="Proveedor"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.price"
                            :app="app"
                            :item="id"
                            name="price"
                            title="Precio"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <g-field
                            v-model="fields.iva"
                            :app="app"
                            :item="id"
                            name="iva"
                            title="IVA %"
                        />
                    </div>
                </div>

                <div
                    :style="{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        padding: '10px 16px',
                        textAlign: 'right'
                    }"
                >
                    <a-button
                        :style="{ marginRight: '8px' }"
                        @click="$emit('close')"
                    >
                        Cancelar
                    </a-button>
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="loading"
                        :disabled="invalid"
                    >
                        {{ id === 0 ? 'Añadir' : 'Modificar' }}
                    </a-button>
                </div>
            </form>
        </validation-observer>
    </a-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            view: 'goodList',
            app: 'goods',
            loading: false,
            fields: {
                name: '',
                iva: 0,
                price: 0,
                provider: null
            }
        };
    },
    methods: {
        async save() {
            this.loading = true;

            const params = {
                name: this.fields.name,
                price: this.fields.price,
                iva: this.fields.iva,
                provider: this.fields.provider ? this.fields.provider.key : null,
            };

            let data;
            if (this.id > 0) {
                data = await this.$gestios.items('goods').edit({ id: this.id, params });
            } else {
                data = await this.$gestios.items('goods').add({ params, view: this.view });
            }

            if (data.ok) this.$emit('close');

            this.loading = false;
        }
    }
};
</script>

<style>
</style>
